import { createFileRoute } from '@tanstack/react-router';
import { FinanceDashboardScreen } from '../../screens/finance/Dashboard';

// FIN-13: the Finance dashboard is the app's landing screen (replacing the
// FIN-9 redirect to Accounts). Current-month money in/out/net, net worth,
// budget progress, savings flow, professional recovery, pending review and
// recent activity — all from the FIN-8 analytics endpoints.
export const Route = createFileRoute('/finance/')({
  component: FinanceDashboardScreen,
});
